import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@ibk/shared-translation';
import { useBenefitMigration } from './useBenefitMigration';
export function useMigrationBenefitsOnboarding() {
    const migration = useBenefitMigration();
    const { scope, isCurrent } = migration;
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [phase, setPhase] = useState('idle');
    const exitOrigin = useRef('intro');
    const scopeKey = migration.scope ? JSON.stringify(migration.scope) : '';
    useEffect(() => {
        exitOrigin.current = 'intro';
        setPhase('idle');
    }, [scopeKey]);
    useEffect(() => {
        if (migration.enabled &&
            migration.state.kind === 'ready' &&
            migration.read?.snapshot.phase === 'complete' &&
            migration.scope &&
            migration.onboarding?.requested) {
            migration.onboarding.consume(migration.scope);
            setPhase('intro');
        }
    }, [migration.enabled, migration.state, migration.read, migration.scope, migration.onboarding, scopeKey]);
    const finish = useCallback((reason) => {
        if (!scope || !isCurrent(scope))
            return;
        if (reason === 'completed' && phase === 'tour')
            setPhase('first-recharge');
        if (reason === 'skipped' && (phase === 'tour' || phase === 'skip-confirm'))
            setPhase('idle');
    }, [scope, isCurrent, phase]);
    const start = () => {
        setPhase('tour');
    };
    const requestExit = () => {
        exitOrigin.current = phase === 'tour' ? 'tour' : 'intro';
        setPhase('skip-confirm');
    };
    const cancelExit = () => setPhase(exitOrigin.current);
    let presentation = 'sample-preview';
    if (phase === 'idle')
        presentation = 'live';
    if (phase === 'intro')
        presentation = 'empty-preview';
    const welcomeModalProps = {
        isOpen: phase === 'intro',
        onClose: requestExit,
        onPrimaryAction: start,
        closeOnPrimaryAction: false,
        title: t('benefits.onboarding.intro.title'),
        description: t('benefits.onboarding.intro.description'),
        primaryActionLabel: t('benefits.onboarding.intro.start'),
        primaryActionLeftIcon: 'none',
        primaryActionRightIcon: 'none',
        actionsButtonSize: 'medium',
        onboardingWelcomeActions: true,
        secondaryActionLabel: t('benefits.onboarding.intro.skip'),
        onSecondaryAction: requestExit,
    };
    return {
        phase,
        start,
        requestExit,
        cancelExit,
        confirmExit: () => finish('skipped'),
        finishTour: () => finish('completed'),
        finish,
        goToFirstRecharge: () => {
            setPhase('idle');
            navigate('/beneficios/nova-recarga');
        },
        stayOnHome: () => setPhase('idle'),
        welcomeModalProps,
        benefitsOnboardingWizard: phase === 'tour' || phase === 'skip-confirm'
            ? {
                mode: phase === 'tour' ? 'tour' : 'skip',
                onReopenFromSkipCancel: cancelExit,
                onFlowFinished: () => { },
            }
            : null,
        presentation,
        isOnboardingPreviewActive: phase !== 'idle',
    };
}
